function getFile(url) {
    const files_api = (process.env.NEXT_PUBLIC_APP_ENV === 'local') ? 'http://2nabsh.local/storage/media' : 'https://files.2nabsh.com/media';
    return files_api + url;
}

export {
    getFile
}